export const modalBodyInjectionKey = Symbol('modalBody');
export const modalInjectionKey = Symbol('modal');
